import { getDatabase, ref, push, set } from "firebase/database";
import { ReturnItemData } from "../../models/credit";

export const saveReturnItem = async (data: ReturnItemData) => {
	const db = getDatabase();
	const creditsRef = ref(db, "returns");
	const newCreditRef = push(creditsRef);
	await set(newCreditRef, data);
};
